export default function (context, val) {
  let b = context.rootGetters['dictionary/paymentOperation/bonuses'].filter(i => {
    return i.InOut === 0
  })[0];
  if (!b) {
    window.app.$router.push('/finances/payments/add/order/' + encodeURIComponent(val.id));
    window.app.$notify.warning({
      message: 'Отсутствует платёжная операция с бонусным типом. Оплата бонусами невозможна.',
    });
    return;
  }
  let date = new Date();
  context.dispatch('set_title', 'Добавление платежей', {root: true});
  context.commit('set_form', {
    Id: 0,
    Name: '',
    NameLat: '',
    CertificateId: '',
    CertificateName: '',
    PaymentDirection: 0,
    PaymentOperationID: b.value,
    RateArticleId: null,
    CategoryId: 2,
    PaymentTypeId: b.PaymentTypeId,
    CashId: null,
    PaymentAccountId: null,
    AccountNumber: '',
    ContragentType: 1,
    ContragentID: null,
    ContragentName: '',
    PartnerLegalEntityId: null,
    Sum: 0,
    CurrencyId: 1,
    PaymentDate: '' + (date.getDate() > 9 ? '' : '0') + date.getDate() + '.' + (date.getMonth() > 8 ? '' : '0') + (date.getMonth() + 1) + '.' + date.getFullYear(),
    DocumentNumber: context.state.system.IncomePaymentNumber,
    Comment: '',
    RegularPaymentTypeId: 0,
    dayMonth: 1,
    dayWeek: 1,
    dayYear: '',
    dayOne: '',
    NotificationsEndDate: '',
    AgreementCodes: [],
  });
  context.dispatch('agreements/add', {
    id: val.id,
    callback: agreement => {
      agreement.requests.forEach(i => {
        i.sum = i.bonus;
      });
      context.commit('set_form', {
        CurrencyId: agreement.AGCurrency,
      });
      context.dispatch('agreement_getCourse', agreement.code);
      setTimeout(() => {
        context.commit('set_form', {
          Sum: context.getters['agreements/sum_all'],
        });
        context.commit('set_load', {
          data: false,
        });
      });
    }
  });
}